/* eslint ember/no-new-mixins:"off" */
import { run } from '@ember/runloop';
import { on } from '@ember/object/evented';
import { computed } from '@ember/object';
import Mixin from '@ember/object/mixin';
import $ from 'jquery';
export default Mixin.create({
  // Note that we don't want this to depend on 'elementId' since we actually
  // don't want it to change if that changes for some reason between setup
  // and cleanup.
  eventNamespace: computed('elementId', function () {
    return `popup-support-${this.elementId}`;
  }),
  // FYI, I tried changing this to just use `didInsertElement()` and
  // `willDestroyElement()` but it caused a bunch of timeouts? `/shrug`
  setupWindowEvents: on('didInsertElement', function () {
    const $window = $(window); // eslint-disable-line ember/no-jquery

    if (this.applicationKeyDown) {
      $window.on(`keydown.${this.eventNamespace}`, (...args) => {
        run(() => this.applicationKeyDown(...args));
      });
    }
    if (this.applicationClick) {
      $window.on(`click.${this.eventNamespace}`, (...args) => {
        run(() => this.applicationClick(...args));
      });
    }
  }),
  // Fun fact that is actually not fun: Calling this function `cleanup` causes
  // it to not get run or something, resulting in "calling set on a destroyed
  // object" errors. So don't call it that I guess? `/shrug`
  cleanupWindowEvents: on('willDestroyElement', function () {
    if (this.applicationKeyDown || this.applicationClick) {
      $(window).off(`.${this.eventNamespace}`); // eslint-disable-line ember/no-jquery
    }
  })
});